<template>
  <div class="share">
    <div class="share__title">{{ $t('blog.share.title', lang) }}</div>
    <!-- Listado de redes para share -->
    <div class="share__items">
      <a
        :href="'whatsapp://send?text=' + $t('blog.share.seenOnHelloBB', lang) + ' ' + currentUrl()"
        class="share__item share__item--whatsapp"
        :aria-label="$t('blog.share.whatsapp', lang)"
      >
        <img
          src="../../../assets/img/ico/ico-share-whatsapp.svg"
          alt="Whatsapp"
          loading="lazy"
        />
      </a>
      <a
        :href="'https://www.facebook.com/sharer/sharer.php?u=' + currentUrl()"
        class="share__item share__item--facebook"
        :aria-label="$t('blog.share.facebook', lang)"
      >
        <img
          src="../../../assets/img/ico/ico-share-facebook.svg"
          alt="Facebook"
          loading="lazy"
        />
      </a>
      <a
        :href="
          'http://pinterest.com/pin/create/button/?url=' +
          post.url +
          '&media=' +
          currentUrl() +
          '&description=' +
          post.excerpt
        "
        count-layout="horizontal"
        class="share__item share__item--pinterest pin-it-button"
        :aria-label="$t('blog.share.pinterest', lang)"
      >
        <img
          src="../../../assets/img/ico/ico-share-pinterest.svg"
          alt="Pinterest"
          loading="lazy"
        />
      </a>

      <a
        :href="
          'https://twitter.com/intent/tweet?text=' + $t('blog.share.seenOnHelloBB', lang) + '&?url=' + currentUrl()
        "
        class="share__item share__item--twitter"
        :aria-label="$t('blog.share.twitter', lang)"
      >
        <img
          src="../../../assets/img/ico/ico-share-twitter.svg"
          alt="Twitter"
          loading="lazy"
        />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Share",
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    lang() {
      return this.$route.meta?.lang || this.$i18n.locale;
    },
  },
  methods: {
    currentUrl() {
      return (
        process.env.APP_URL.substring(0, process.env.APP_URL.length - 1) +
        this.$route.path
      );
    },
  },
};
</script>
